// Adapts a shared field component's generic onChange(field, value) callback
// to a flat, prefixed state setter — e.g. withPrefix('msg', setField) turns
// onChange('title', v) into setField('msgTitle', v). Used by CampaignWizard,
// which keeps one flat state object across all channels; the journey
// ConfigDrawer doesn't need this since its node.cfg keys are already unprefixed.
export function withPrefix(prefix, onField) {
  return (field, value) => onField(prefix + field[0].toUpperCase() + field.slice(1), value);
}
